import { render, staticRenderFns } from "./RealCorrectScore.vue?vue&type=template&id=615c54fa&scoped=true&"
import script from "./RealCorrectScore.vue?vue&type=script&lang=js&"
export * from "./RealCorrectScore.vue?vue&type=script&lang=js&"
import style0 from "./RealCorrectScore.vue?vue&type=style&index=0&id=615c54fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615c54fa",
  null
  
)

export default component.exports